import React from 'react';
import { Table, Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

function ShoppingCart({ cart, setCart }) {
  const [showClearConfirmation, setShowClearConfirmation] = useState(false);

  const removeFromCart = (idLevels) => {
    setCart(prevCart => prevCart.filter(item => item.idLevels !== idLevels));
  };

  const updateQuantity = (idLevels, newQuantity) => {
    if (newQuantity < 1) return;
    setCart(prevCart => prevCart.map(item => {
      if (item.idLevels === idLevels) {
        const availQty = Number(item.availQty);
        return { ...item, quantity: Math.min(newQuantity, availQty) };
      }
      return item;
    }));
  };

  const handleClearCart = () => {
    setCart([]);
    setShowClearConfirmation(false);
  };

  return (
    <div className="shopping-cart">
      {cart.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th>Available</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {cart.map(item => (
                <tr key={item.idLevels}>
                  <td>{item.itemName}</td>
                  <td>
                    <Button size="sm" onClick={() => updateQuantity(item.idLevels, item.quantity - 1)} disabled={item.quantity <= 1}>
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                    <span className="mx-2">{item.quantity}</span>
                    <Button size="sm" onClick={() => updateQuantity(item.idLevels, item.quantity + 1)} disabled={item.quantity >= Number(item.availQty)}>
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </td>
                  <td>{item.availQty}</td>
                  <td>
                    <Button variant="danger" size="sm" onClick={() => removeFromCart(item.idLevels)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end">
            <Button 
              variant="danger" 
              size="sm"
              onClick={() => setShowClearConfirmation(true)}
            >
              Clear Cart
            </Button>
          </div>

          {/* Clear Cart Confirmation Modal */}
          <Modal 
            show={showClearConfirmation} 
            onHide={() => setShowClearConfirmation(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Clear Cart</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to clear all items from your cart?
            </Modal.Body>
            <Modal.Footer>
              <Button 
                variant="secondary" 
                onClick={() => setShowClearConfirmation(false)}
              >
                Cancel
              </Button>
              <Button 
                variant="danger" 
                onClick={handleClearCart}
              >
                Clear Cart
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  );
}

export default ShoppingCart;
